import * as React from "react";
const SvgBattery = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M16 6.10526H14.5179V4H0V12.0337H14.5179V9.91158H16V6.10526ZM13.5 11H1V5H13.5V11Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.82251 5.53271H1.54883V10.4843H3.82251V5.53271Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.87134 5.53271H4.59766V10.4843H6.87134V5.53271Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.92407 5.53271H7.65039V10.4843H9.92407V5.53271Z",
	fill: "currentColor"
}));
export default SvgBattery;
